<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :class="isDisabledIconInAttr || isGuest ? 'disabled-icon' : ''"
    @click="processAddBookmarkEvent()"
  >
    <BaseSpriteIcon icon-name="ico-bookmark"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.bookmark') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';
import PromiseUtil from '@/services/utils/PromiseUtil';

export default {
  name: 'BookmarkControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    currentLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    isGuest() {
      return this.$store.getters['UserStore/isGuestUser'];
    },
    isDisabledIconInAttr() {
      return this.$attrs['icon-disabled'];
    }
  },
  methods: {
    getBookmarksByBlockId() {
      const paraId = this.currentLocator?.startLocator?.prefixedParagraphId;
      return this.$store.getters['BookmarkStore/getBookmarksByBlockId']({
        bookId: this.bookId,
        paraId
      });
    },
    addBookmark() {
      const { paraNum } = this.$store.getters['BookStore/getParaMetaByLocator'](
        this.currentLocator
      );
      return this.$store.dispatch('BookmarkStore/addBookmarkByLocator', {
        locator: this.currentLocator,
        paraNum
      });
    },
    deleteBookmark(bookmark) {
      this.$store.dispatch('BookmarkStore/deleteBookmark', {
        bookmark
      });
    },
    openSucessToaster() {
      this.$store.dispatch('ManagePopupStore/openToaster', {
        toasterIcon: 'ico-bookmark',
        text: this.$t('CreateBookmark.toaster.message'),
        toasterClose: false
      });
    },
    openErrorToaster() {
      this.$store.dispatch('ManagePopupStore/openToaster', {
        text: this.$t('CreateBookmark.toaster.error.message'),
        toasterClose: false
      });
    },
    processAddBookmarkEvent() {
      if (this.isDisabledIconInAttr && !this.isGuest) {
        this.$store.dispatch('ManagePopupStore/openToaster', {
          text: this.$t('BookmarkControl.toaster.disabled.message'),
          toasterClose: false
        });
        return;
      }
      this.$store.dispatch('PaymentsStore/wrappWithGuestLogic', {
        handler: this.createBookmark
      });
    },
    async createBookmark() {
      const bookmarkInCurrentPara = this.getBookmarksByBlockId();
      if (bookmarkInCurrentPara?.length) {
        this.deleteBookmark(bookmarkInCurrentPara[0]);
        await PromiseUtil.wait(200);
      }

      const isBookmarkCreated = await this.addBookmark();
      if (isBookmarkCreated) {
        this.openSucessToaster();
      } else {
        this.openErrorToaster();
      }
    }
  }
};
</script>
